import Vue from 'vue'
import { Loading } from 'element-ui'
// loading封装
export const loadings = (e) => {
  const loading = Loading.service({
    lock: true,
    text: 'loading......',
  })
  if (e == '0') {
    loading.close()
  }
}
// 时间格式化
export const calculateSum = (e) => {
  //dataString是整数，否则要parseInt转换
  var time = new Date()
  var year = time.getFullYear()
  var month = time.getMonth() + 1
  var day = time.getDate()
  var hour = time.getHours()
  var minute = time.getMinutes()
  var second = time.getSeconds()
  if (Number(month) + 1 == 13) {
    var old_month = 1
    var old_year = year
  } else {
    var old_month = month + 1
    var old_year = year - 1
  }
  if (Number(month) - 1 == 0) {
    var last_month = 12
  } else {
    var last_month = month - 1
  }
  let today_select = year + '-' + (Number(month) < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
  let month_select = year + '-' + (Number(month) < 10 ? '0' + month : month)
  let month_one = year + '-' + (Number(month) < 10 ? '0' + month : month) + '-' + '01'
  let old_year_month = old_year + '-' + (Number(old_month) < 10 ? '0' + old_month : old_month)
  let new_year_month = year + '-' + '12'
  let mid_year_month = year + '-' + '06'
  let now_year_month = year + '-' + '01'
  let year_last_month = year + '-' + (Number(last_month) < 10 ? '0' + last_month : last_month)
  if (e == 1) {
    return today_select //2025-04-09 当前年月日
  } else if (e == 2) {
    return month_one //当前年-当前月-01
  } else if (e == 3) {
    return old_year_month //2024-05 去年当前月
  } else if (e == 4) {
    return new_year_month //2025-12 今年12月
  } else if (e == 5) {
    return now_year_month //2025-01 今年1月
  } else if (e == 6) {
    return mid_year_month //2025-06 今年6月
  } else if (e == 7) {
    return year_last_month //2025-03 当前年-上个月
  } else if (e == 8) {
    return last_month //上个月
  } else if (e == 9) {
    return month //当前月
  } else {
    return month_select //当前年-当前月
  }
}
// export default { calculateSum }
